import { normalizeMap } from '../lib'
import templateOptionProp from './templateOptionProp'

export default function (props) {
  const res = {}
  normalizeMap(props).forEach(({key, val}) => {
    res[key] = templateOptionProp(key, val)
  })
  return res
}



// WEBPACK FOOTER //
// ./src/utils/mapTemplateOptions.js